import BaseScene from "@Scenes/BaseScene";

/*-------------- Config -------------------*/
import * as Scenes from '@Config/scenes';

/*--------------- Player ------------------*/

class ChallengersScene extends BaseScene
{
    /*------------------- Leaderboard Entries ----------------------*/
    private constextPlayersLeaderboardEntries: Networks.LeaderboardEntry[];

    /*------------------- Game Objects ----------------------*/
    private gameObjects: Phaser.GameObjects.GameObject[];
    private challengerImage: Phaser.GameObjects.Image;
    private challengerName: Phaser.GameObjects.Text;
    private challengerScore: Phaser.GameObjects.Text;


    /*------------------- Tween ----------------------*/
    private tween: Phaser.Tweens.Tween;
    private tweenOffsetX: number;

    constructor()
    {
        super(Scenes.CHALLENGERS);
        this.tweenOffsetX = 200;

    }

    /**
     * Initialize Scene
     * @param playerLeaderboardEntry
     */
    public init(constextPlayersLeaderboardEntries: Networks.LeaderboardEntry[])
    {
        this.constextPlayersLeaderboardEntries = constextPlayersLeaderboardEntries;
        this.gameObjects = [];
    }

    /**
     * Preloads assets required for the scene
     */
    public preload()
    {
        const leaderboardEntries = this.constextPlayersLeaderboardEntries;

        for (const leaderboardEntry of leaderboardEntries)
        {
            const player = leaderboardEntry.getPlayer();

            const playerID = player.getID();

            const playerImageKey = `player-${playerID}`;

            if (this.textures.exists(playerImageKey) === false)
            {
                this.load.image(playerImageKey, player.getPhoto());
            }
        }

    }

    /**
     * Creates the UI of the scene
     */
    public create()
    {
        this.addPlayerImage();
        this.setChallenger();
    }

    /**
     * Adds a player image to the scene
     */
    private addPlayerImage()
    {
        const gameSize = this.getGameSize();

        /*---------------- Positioning -----------------*/
        const playerX = (gameSize.width - 97) + this.tweenOffsetX;
        const playerY = 67;

        /*--------------- Circle Mask -----------------*/
        const circleMask = this.make.graphics({});
        circleMask.fillStyle(0xffffff);
        circleMask.lineStyle(2, 0x000000);
        circleMask.strokeCircle(0, 0, 20);
        circleMask.fillCircle(0, 0, 20);
        circleMask.x = playerX;
        circleMask.y = playerY;

        /*------------------ Image --------------------*/
        const mask = circleMask.createGeometryMask();
        const image = this.add.image(playerX, playerY, '');
        image.setDisplaySize(70, 70)
        image.setMask(mask);
        image.setOrigin(0.5);

        /*------------------ Text --------------------*/
        const fontStyle = { fontFamily: 'Permanent Marker', color: '#000000', fontSize: '20px', align: 'right' };

        const challengerName = this.add.text((playerX - 33), 45, '', fontStyle);
        challengerName.setOrigin(1, 0);

        const challengerScore = this.add.text((playerX - 33), 67, '', fontStyle);
        challengerScore.setOrigin(1, 0);
        challengerScore.setAlign('right');

        /*-------------- Set Properties --------------*/
        this.challengerScore = challengerScore;
        this.challengerName = challengerName;
        this.challengerImage = image

        /*------------- Group Game Objects ------------*/
        this.gameObjects.push(
            circleMask,
            challengerScore,
            challengerName,
            image
        )

    }

    /**
     * Set challenger
     */
    private setChallenger()
    {
        if( this.constextPlayersLeaderboardEntries.length > 0 )
        {
            const leaderboardChallengerEntry = this.constextPlayersLeaderboardEntries[0];

            const player = leaderboardChallengerEntry.getPlayer();
            const playerID = player.getID();
            const playerImageKey = `player-${playerID}`;

            this.challengerName.setText(player.getName());
            this.challengerImage.setTexture(playerImageKey);
            this.challengerImage.setDisplaySize(70, 70);

            this.challengerScore.setText(leaderboardChallengerEntry.getFormattedScore());
            this.challengerScore.setOrigin(1, 0);

            this.tweenIn();
        }
    }

    /**
     * Tween In
     */
    private tweenIn()
    {
        this.add.tween({
            targets: this.gameObjects,
            props: {
                x: { value: `-=${this.tweenOffsetX}`, duration: 500, ease: 'Sine.easeOut' }
            }
        });
    }

}

export default ChallengersScene;